import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./AllTransactions.css";
import { getCoinIcon } from "../utils/coinIcons";
import bankWithdrawalIcon from "../assets/bank.png";
import paypalIcon from "../assets/paypal.png";
import spinWheelIcon from "../assets/spinandwin.png"; // Add this import

/* ================= WHATSAPP FLOAT COMPONENT ================= */
const WhatsAppFloat = ({
  phoneNumber = "15485825756",
  message = "Hello! I need assistance with my transaction history on InstaCoinXPay.",
  position = "right",
  bottom = "30px",
  right = "30px",
  left = "auto",
  size = "54px",
  iconSize = "28px",
  pulseEffect = true,
  className = "",
  style = {},
}) => {
  const formattedNumber = phoneNumber.replace(/[^\d]/g, "");
  const whatsappUrl = `https://wa.me/${formattedNumber}?text=${encodeURIComponent(message)}`;
  const positionStyles =
    position === "left"
      ? { left: left || "20px", right: "auto" }
      : { right: right || "20px", left: "auto" };

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer nofollow"
      className={`whatsapp-float ${pulseEffect ? "pulse" : ""} ${className}`}
      style={{
        position: "fixed",
        bottom,
        width: size,
        height: size,
        borderRadius: "50%",
        backgroundColor: "#25d366",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
        zIndex: 10000,
        cursor: "pointer",
        textDecoration: "none",
        ...positionStyles,
        ...style,
      }}
    >
      <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="white">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
      </svg>
    </a>
  );
};

/* ================= SPIN WHEEL NAVIGATION BUTTON (Navigates to SpinWheel) ================= */
const SpinWheelNavButton = ({ 
  position = "right",
  bottom = "100px", // Positioned above WhatsApp button
  right = "30px",
  left = "auto",
  size = "100px",
  pulseEffect = true,
  className = "",
  style = {}
}) => {
  const navigate = useNavigate();
  
  const positionStyles = position === "left" 
    ? { left: left || "20px", right: "auto" }
    : { right: right || "20px", left: "auto" };

  const combinedStyles = {
    position: 'fixed',
    bottom: bottom,
    width: size,
    height: size,
    borderRadius: '50%',
    background: 'radial-gradient(circle at 30% 30%, #f7931a, #c8930a)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 8px 25px rgba(247, 147, 26, 0.5), 0 0 20px rgba(200, 147, 10, 0.4)',
    zIndex: 10000,
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    textDecoration: 'none',
    border: '3px solid rgba(255, 215, 0, 0.6)',
    overflow: 'hidden',
    padding: '0px',
    ...positionStyles,
    ...style
  };

  // Add keyframes for pulse animation if not already defined
  React.useEffect(() => {
    if (!document.querySelector('#spin-wheel-nav-keyframes-transactions')) {
      const styleSheet = document.createElement("style");
      styleSheet.id = 'spin-wheel-nav-keyframes-transactions';
      styleSheet.textContent = `
        @keyframes spinWheelNavPulse {
          0% {
            box-shadow: 0 8px 25px rgba(247, 147, 26, 0.5), 0 0 20px rgba(200, 147, 10, 0.4), 0 0 0 0 rgba(247, 147, 26, 0.7);
          }
          70% {
            box-shadow: 0 8px 35px rgba(247, 147, 26, 0.7), 0 0 30px rgba(200, 147, 10, 0.6), 0 0 0 15px rgba(247, 147, 26, 0);
          }
          100% {
            box-shadow: 0 8px 25px rgba(247, 147, 26, 0.5), 0 0 20px rgba(200, 147, 10, 0.4), 0 0 0 0 rgba(247, 147, 26, 0);
          }
        }
        
        @keyframes spinWheelNavGlow {
          0% {
            filter: drop-shadow(0 0 5px #f7931a);
          }
          50% {
            filter: drop-shadow(0 0 15px #c8930a);
          }
          100% {
            filter: drop-shadow(0 0 5px #f7931a);
          }
        }
        
        @keyframes spinWheelNavRotate {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
        
        .spin-wheel-nav-float {
          animation: ${pulseEffect ? 'spinWheelNavPulse 2s infinite, spinWheelNavGlow 3s infinite' : 'none'};
        }
        
        .spin-wheel-nav-float:hover {
          transform: scale(1.15) rotate(10deg) !important;
          background: radial-gradient(circle at 30% 30%, #ffd700, #f7931a) !important;
          box-shadow: 0 10px 40px rgba(247, 147, 26, 0.8), 0 0 35px rgba(255, 215, 0, 0.7) !important;
        }
        
        .spin-wheel-nav-float:hover .wheel-icon-image {
          transform: scale(1.2) rotate(15deg) !important;
        }
        
        .wheel-icon-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 50%;
          transition: transform 0.3s ease;
        }
      `;
      document.head.appendChild(styleSheet);
    }
  }, [pulseEffect]);

  const handleClick = () => {
    navigate('/spinwheel');
  };

  return (
    <button
      onClick={handleClick}
      className={`spin-wheel-nav-float ${className}`}
      style={combinedStyles}
      aria-label="Go to Fortune Wheel"
      title="Spin the Fortune Wheel!"
    >
      <img 
        src={spinWheelIcon} 
        alt="Fortune Wheel"
        className="wheel-icon-image"
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          borderRadius: '50%',
          transition: 'transform 0.3s ease',
          transform: 'scale(1.1)'
        }}
      />
      
      <div style={{
        position: 'absolute',
        inset: '-6px',
        borderRadius: '50%',
        border: '3px solid rgba(255, 215, 0, 0.5)',
        borderTopColor: '#f7931a',
        borderRightColor: '#ffd700',
        borderBottomColor: '#f7931a',
        borderLeftColor: '#ffd700',
        opacity: 0.9,
        animation: 'spinWheelNavRotate 4s linear infinite',
        pointerEvents: 'none',
        boxShadow: '0 0 15px rgba(247, 147, 26, 0.6)'
      }} />
      
      <div style={{
        position: 'absolute',
        inset: '2px',
        borderRadius: '50%',
        border: '1px solid rgba(255, 255, 255, 0.3)',
        opacity: 0.5,
        pointerEvents: 'none'
      }} />
    </button>
  );
};

/* ================= HELPERS ================= */
const normalizeStatus = (tx) => {
  const status = tx.status?.toLowerCase();
  if (status === "completed") return "Successful";
  if (status === "failed") return "Failed";
  return "Pending";
};

// ✅ Detect referral reward from notes field
const isReferralReward = (tx) => {
  try {
    const notes = typeof tx.notes === "string" ? JSON.parse(tx.notes) : tx.notes;
    return notes?.type === "REFERRAL_REWARD";
  } catch {
    return false;
  }
};

const getTypeLabel = (type, tx) => {
  if (isReferralReward(tx)) return "Referral Reward";
  const t = type?.toLowerCase();
  if (t === "send") return "Send";
  if (t === "receive") return "Receive";
  if (t === "paypal_withdrawal") return "PayPal Withdrawal";
  if (t === "bank_withdrawal") return "Bank Withdrawal";
  if (t === "pending") return "Pending";
  return type || "Unknown";
};

const getAmountClass = (type) => {
  const t = type?.toLowerCase();
  if (t === "receive") return "tx-amount-unique received";
  if (t === "send" || t === "paypal_withdrawal" || t === "bank_withdrawal")
    return "tx-amount-unique sent";
  return "tx-amount-unique pending";
};

const getTypeClass = (type) => {
  const t = type?.toLowerCase();
  if (t === "receive") return "tx-type-unique received";
  if (t === "send" || t === "paypal_withdrawal" || t === "bank_withdrawal")
    return "tx-type-unique sent";
  return "tx-type-unique pending";
};

/* ================= COMPONENT ================= */
const AllTransactions = () => {
  const navigate = useNavigate();
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const fetchGroupedTransactions = async () => {
    try {
      setLoading(true);
      setError("");

      const token = localStorage.getItem("token");
      if (!token) return navigate("/login");

      const res = await axios.get(
        "https://backend-srtt.onrender.com/api/history/grouped/all",
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const normalized = (res.data?.data || []).map((group) => ({
        date: group.date,
        items: (group.items || []).map((tx, index) => ({
          id:            tx.id || `${group.date}-${index}`,
          type:          tx.type || "Unknown",
          coin:          tx.coin || "N/A",
          to:            tx.to || "—",
          fullAddress:   tx.fullAddress,
          amount:        tx.amount,
          sub:           tx.sub || "",
          status:        normalizeStatus(tx),
          confirmations: tx.confirmations || null,
          notes:         tx.notes || null,   // ✅ needed for referral detection
        })),
      }));

      setTransactions(normalized);
    } catch (err) {
      setError("Failed to load transactions");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchGroupedTransactions();
  }, []);

  return (
    <>
      <div className="tx-wrapper-unique">
        <div className="tx-card-unique">
          <div className="tx-header-unique">
            <span className="tx-back-unique" onClick={() => navigate(-1)}>←</span>
            <h2>All Transactions</h2>
          </div>

          {loading && <p className="tx-loading-unique">Loading...</p>}
          {error   && <p className="tx-error-unique">{error}</p>}

          {transactions.map((group, i) => (
            <div key={i}>
              <p className="tx-date-unique">{group.date}</p>

              {group.items.map((tx) => {
                const isBankWithdrawal =
                  tx.type === "BANK_WITHDRAWAL" ||
                  tx.fullAddress === "BANK_WITHDRAWAL";

                const isPaypalWithdrawal =
                  tx.type === "PAYPAL_WITHDRAWAL" ||
                  tx.to === "PayPal" ||
                  tx.fullAddress === "PayPal";

                // ✅ referral detection
                const isReferral = isReferralReward(tx);

                return (
                  <div
                    key={tx.id}
                    className="tx-row-unique clickable"
                    onClick={() => {
                      if (isBankWithdrawal) {
                        navigate("/bankwithdrawalreceipt", {
                          state: { transferId: tx.id },
                        });
                        return;
                      }

                      if (isPaypalWithdrawal) {
                        const payload = {
                          transferId:    tx.id,
                          transactionId: tx.id,
                          asset:         tx.coin?.toLowerCase() || "btc",
                          amount:        Number(tx.sub?.split(" ")[0]) || 0,
                          usdAmount:     Number(String(tx.amount).replace(/[^0-9.]/g, "")) || 0,
                          paypalEmail:   tx.to || "—",
                          confirmations: tx.confirmations || [false, false, false, false],
                        };
                        sessionStorage.setItem("paypalReceipt", JSON.stringify(payload));
                        navigate("/paypalwithdrawalreceipt", { state: payload });
                        return;
                      }

                      navigate(`/transaction/${tx.id}`, { state: tx });
                    }}
                  >
                    <div className="tx-left-unique">
                      <div className="tx-icon-unique">
                        {/* ✅ Referral reward: gift emoji instead of coin icon */}
                        {isReferral ? (
                          <span style={{ fontSize: "28px", lineHeight: 1 }}>🎁</span>
                        ) : (
                          <img
                            src={
                              isBankWithdrawal
                                ? bankWithdrawalIcon
                                : isPaypalWithdrawal
                                ? paypalIcon
                                : getCoinIcon(tx.coin, tx.sub)
                            }
                            alt={tx.coin}
                            className="tx-coin-img-unique"
                          />
                        )}
                      </div>

                      <div>
                        {/* ✅ Shows "Referral Reward" for referral txns */}
                        <strong className={getTypeClass(tx.type)}>
                          {getTypeLabel(tx.type, tx)}
                        </strong>

                        {/* ✅ Shows short tx hash (e.g. "0x1a2b3c...9f3e1d") not "Admin Wallet" */}
                        <span>
                          {isReferral
                            ? `TxID: ${tx.to}`
                            : tx.type?.toLowerCase() === "receive"
                            ? `From: ${tx.to}`
                            : `To: ${tx.to}`}
                        </span>
                      </div>
                    </div>

                    <div className="tx-right-unique">
                      <span className={getAmountClass(tx.type)}>
                        {tx.amount}
                      </span>

                      {tx.sub && <small>{tx.sub}</small>}

                      <small className={`tx-status-unique ${tx.status.toLowerCase()}`}>
                        {tx.status}
                      </small>
                    </div>
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      </div>

      {/* WhatsApp Float Button */}
      <WhatsAppFloat />

      {/* Spin Wheel Navigation Button - On Right Side ABOVE WhatsApp */}
      <SpinWheelNavButton 
        position="right"
        bottom="100px"
        right="30px"
        pulseEffect={true}
        size="60px"
      />
    </>
  );
};

export default AllTransactions;